export type ValidationRuleForMultiple = {
  regex?: string;
  minLength?: number;
  maxLength?: number;
  errorMessage?: string;
};
export type ValidationRule = {
  value?: string;
  minLength?: number;
  maxLength?: number;
  errorMessage?: string;
};

export interface AttributeForValidation {
  name: string;
  attributeId: any;
  isRequired: boolean;
  validationRules: ValidationRuleForMultiple[];
  label: string;
}

export interface AttributeValue {
  attributeId: any;
  value: any;
}

export const validateValue = (
  value: string,
  rules: ValidationRule[]
): string | null => {
  for (const rule of rules) {
    if (rule.value && !new RegExp(rule.value).test(value)) {
      return rule.errorMessage || "Invalid format";
    }
    if (rule.minLength !== undefined && value.length < rule.minLength) {
      return rule.errorMessage || `Minimum length is ${rule.minLength}`;
    }
    if (rule.maxLength !== undefined && value.length > rule.maxLength) {
      return rule.errorMessage || `Maximum length is ${rule.maxLength}`;
    }
  }
  return null; // No errors
};
export function validateAttributesAgainstPayload(
  attributes: AttributeForValidation[],
  payloadAttributes: AttributeValue[]
): Record<string, string> {
  const errors: Record<string, string> = {};
  attributes.forEach((attribute) => {
    const userAttribute = payloadAttributes.find(
      (a) => a.attributeId === attribute.attributeId
    );
    if (attribute.isRequired && userAttribute) {
      const errorMessage = validateValue(
        userAttribute.value,
        attribute.validationRules
      );
      if (errorMessage) {
        errors[attribute.name] = errorMessage;
      }
    }
  });
  return errors;
}

export const maskBankValue = (value: string): string => {
  const visible = value?.slice(-4);
  const masked = '*'.repeat(Math.max(value?.length - 4, 0));
  return masked + visible;
};

